<template>
  <div>
    <div class="bodyFake">
      <img
        class="img-responsive position-absolute"
        src="@/assets/img/mockups/pc-mockup.png"
        style="
          height: 510px;
          width: 100%;
          margin: 0;
          margin-top: -15px;
          margin-left: -5%;
          position: relative;
          z-index: 7;
        "
      />
      <div :style="`${headerStyle}`" class="pt-2 pb-3">
        <b-row style="`${headerStyle}`" class="px-4">
          <b-col cols="12" class=" d-flex justify-content-center">
            <span :style="fontHeaderStyle" class="fs-12 d-none d-sm-block">Atendimento (xx) xxxxx-xxxx |</span>
            <span :style="fontHeaderStyle" class="fs-12 ml-3 d-none d-sm-block">Segurança e privacidade |</span>
            <span :style="fontHeaderStyle" class="fs-12 ml-3">Contato </span>
          </b-col>
          <b-col
            cols="12"
            class="d-flex align-items-center justify-content-between mt-1"
            >
            <b-img
              v-if="companyLogo"
              :src="`${getImagesAddressApp}${companyLogo}`"
              fluid
              width="40%"
            ></b-img>
            <b-input placeholder="Buscar produto" :style="`border-color: ${iconStyle} width: 40%; height:80%`"></b-input>
            <i class="icon-search d-none d-sm-block fas fa-search" :style="`${iconStyle}`"></i>
            <span :style="fontHeaderStyle" class="fs-12 d-none d-sm-block">Crie a sua conta</span>
            <span :style="fontHeaderStyle" class="fs-12">Entre</span>
            <i class="fas fa-map-marker-alt d-none d-sm-block" :style="`${iconStyle}`">
              <span :style="fontHeaderStyle" class="ml-1 fs-12">Oferta para: <strong>Sua cidade</strong></span>
            </i>
            <i class="fas fa-cart-plus" :style="`${iconStyle}`"></i>
          </b-col>
        </b-row>
      </div>

      <div :style="`${accessHeaderMenu}`" class=" py-2 mb-3">
        <b-row>
          <b-col cols="12" class=" d-flex justify-content-around">
            <i class="fas fa-tools" :style="iconOptions"> <span :style="fontColorMenuOptions"> Opção 1</span></i>
            <i class="fas fa-hammer" :style="iconOptions"> <span :style="fontColorMenuOptions"> Opção 2</span></i>
            <i class="fas fa-paint-roller" :style="iconOptions"> <span :style="fontColorMenuOptions"> Opção 3</span></i>
            <i class="fas fa-faucet" :style="iconOptions"> <span :style="fontColorMenuOptions"> Opção 4</span></i>
          </b-col>
        </b-row>
      </div>
    
        <div :style="`${backgroundStyle}`" class="margin-body ">
          <div  style="height: 120px;" class="ml-3 mr-3">
            <b-img
              v-if="companyBanner"
              :src="`${getImagesAddressApp}${companyBanner}`"
              class="img-fluid h-100 w-100"
            >
            </b-img>
            <b-skeleton v-else no-aspect height="120px" style="cursor: default;"></b-skeleton>
          </div>
          <b-row class="ml-2 mr-2">
            <!-- CATEGORIA 01 -->
            <b-col cols="12" class="mt-1" v-if="categoryFirstName != ''">
              <div class="font-weight-bold" :style="fontStyle">{{ categoryFirstName }}</div>
              <b-row>
                <b-col :cols="phone == true ? '4' : '2'" v-for="index in phone == true ? 3 : 6" :key="index">
                  <img :src="`${getImagesAddressApp}produto.png`" class="itemProdutoFake" :alt="'Produto '+index">
                </b-col>
              </b-row>
            </b-col>
    
            <!-- CATEGORIA 02 -->
            <b-col cols="12" class="mt-1" v-if="categorySeccondName != ''">
              <div class="font-weight-bold" :style="fontStyle">{{ categorySeccondName }}</div>
              <b-row>
                <b-col :cols="phone == true ? '4' : '2'" v-for="index in phone == true ? 3 : 6" :key="index" class="mb-1">
                  <img :src="`${getImagesAddressApp}produto.png`" class="itemProdutoFake" :alt="'Produto '+index">
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import UserTypes from '@/enums/UserTypes';

export default {
  name: 'FakeWeb',
  props: {
    headerMenuColor: {
      type: String,
      required: false,
      default: 'white',
    },
    headerMenu: {
      type: String,
      required: false,
      default: 'white',
    },
    backgroundColor: {
      type: String,
      required: false,
      default: 'white',
    },
    iconColor: {
      type: String,
      required: false,
      default: 'black',
    },
    fontColorMenuOption: {
      type: String,
      required: false,
      default: 'black',
    },
    iconOptionsColor: {
      type: String,
      required: false,
      default: 'black',
    },
    fontColor: {
      type: String,
      required: false,
      default: 'black',
    },
    fontHeaderColor: {
      type: String,
      required: false,
      default: 'black',
    },
    atualizar: {
      type: Boolean,
      required: false
    },
    items: {
      type: Array,
    },
  },
  computed: {
    ...mapState(['dadosUsuario']),
    ...mapGetters('general', ['getImagesAddressApp']),
    fontColorMenuOptions() {
      return `color: ${this.fontColorMenuOption};`;
    },
    iconStyle() {
      return `color: ${this.iconColor};`;
    },
    iconOptions() {
      return `color: ${this.iconOptionsColor};`;
    },
    fontStyle() {
      return `color: ${this.fontColor};`;
    },
    fontHeaderStyle() {
      return `color: ${this.fontHeaderColor};`;
    },
    backgroundStyle() {
      return `background-color: ${this.backgroundColor};`;
    },
    headerStyle() {
      return `background-color: ${this.headerMenuColor};`;
    },
    accessHeaderMenu() {
      return `background-color: ${this.headerMenu};`;
    },
  },
  watch: {
    opened(newValue) {
      if (!newValue) return;

      setTimeout(() => {
        this.addMenuBackgroundColor();
      }, 10);
    },
    backgroundColor() {
      this.addAppBackgroundColor();
      this.addMenuBackgroundColor();
    },
    atualizar() {
      this.categoryCompany();
    }
  },
  data() {
    return {
      opened: false,
      phone: false,
      companyLogo: '',
      companyBanner: '',
      categoryFirstName: '',
      categorySeccondName: '',
      categoryThirdName: '',
      categorias: [],
      isGet: true,
    };
  },
  mounted() {
    var larguraDaTela = window.innerWidth;
    if(larguraDaTela < 700) {
      this.phone = true;
    }

    this.getCompanyLogo();
    this.addMenuBackgroundColor();
    this.addAppBackgroundColor();
    this.getCompanyBanner();
    this.isGet === true ? this.get() : this.categoryCompany();
  },
  methods: {
    ...mapActions('shopkeeper', ['getAboutCompany', 'listBanner', 'getMenusApp']),
    addMenuBackgroundColor() {
      const menuBackground =
        document.getElementsByClassName('b-sidebar-body')[0];

      if (!menuBackground) return;

      menuBackground.style.backgroundColor = this.backgroundColor;
    },

    get() {
      this.$store.dispatch('startLoader');
      this.getMenusApp(this.userTypeId())
        .then((response) => {
          const data = response.data.data;
          if(data.length == 0) {
            this.ordem = 1;
            return;
          }
          let orders = [];
          this.items = [];
          this.itemsInactive = [];
          data.forEach(element => {
              let index = 0;
            if(element.status == 1) {
              this.itemsInactive.push(element);
              this.itemsInactive[index].order = null;
              index++;
            } else {
              this.items.push(element);
              orders.push(element.order)
            }
          });
            this.ordemButton = Math.max(...orders) + 1;
            if(this.orderButtom > 0) {
              this.ordem = this.itemsInactive.length += this.ordemButton;
            } else {
              this.ordem = this.ordemButton;
            }
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer as categorias!',
            'danger'
          );
        })
        .finally(() => {
          this.atualizar = !this.atualizar;
          this.$store.dispatch('endLoader');
        });
    },

    addAppBackgroundColor() {
      const appBackground = document.getElementsByClassName('card')[0];

      if (!appBackground) return;

      appBackground.style.backgroundColor = this.backgroundColor;
    },
    async getCompanyLogo() {
      this.getAboutCompany(this.userTypeId())
        .then((response) => {
          const { logo } = response.data.data || {};
          this.companyLogo = logo || 'logo.png';
        })
        .catch(() => {})
        .finally(() => {});
    },

    getCompanyBanner() {
      this.listBanner(this.userTypeId())
        .then((response) => {
          const { image } = response.data.data[0] || {};
          this.companyBanner = image || 'banner.png';
        })
        .catch(() => {})
        .finally(() => {});
    },

    categoryCompany() {
      this.categorias = [];
      if(this.items == undefined) {
        this.categoryFirstName = 'Categoria 1';
        this.categorySeccondName = 'Categoria 2';
        this.categoryThirdName = 'Categoria 3';
        return;
      }

      this.items.forEach(element => {
        if(element.status == 0) {
          this.categorias.push(element)
        }
      });
      const { name } = this.categorias[0] || {};
      this.categoryFirstName = name || '';
      
      const nameCategory  = this.categorias[1].name || {};
      this.categorySeccondName = nameCategory || '';

      const nameCategoryThird  = this.categorias[2].name || {};
      this.categoryThirdName = nameCategoryThird || '';
  },
  userTypeId(){
    return this.$route.meta.userType  == UserTypes.BALCONISTA ? this.dadosUsuario.construp_user_id : this.dadosUsuario.id;
  },
  },
};
</script>

<style scoped>
.itemProdutoFake {
  height: 78px;
  padding: 0;
  margin: 0;
}

.margin-body {
  margin-top: -20px;
}

.icon-search {
  margin-left: -30px;
}

@media (max-width: 768px) {
  .bodyFake {
    width:96%;
  } 
}

@media (min-width: 769px) {
  .bodyFake {
    width:94%;
  } 
}
</style>